import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '../users/auth.guard';

import {SupplierListPageComponent} from './supplier-list-page.container';
import {SupplierDetailPageComponent} from './supplier-detail-page.container';
import {SimpleTravelListPageComponent} from './simple-travel-list-page.container';
import {SimpleTravelDetailPageComponent} from './simple-travel-detail-page.container';


const productRoutes: Routes = [
  { path: 'products/simpleTravels', component: SimpleTravelListPageComponent, canActivate: [AuthGuard] },
  { path: 'products/simpleTravel/:id', component: SimpleTravelDetailPageComponent, canActivate: [AuthGuard] },
  { path: 'products/suppliers', component: SupplierListPageComponent, canActivate: [AuthGuard] },
  { path: 'products/suppliers/:id', component: SupplierDetailPageComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(productRoutes)],
  exports: [RouterModule]
})
export class ProductRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/product/product-routing.module.ts